import { render, staticRenderFns } from "./upDownCard.vue?vue&type=template&id=21bad806"
import script from "./upDownCard.vue?vue&type=script&lang=js"
export * from "./upDownCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports